var _a, _b;
import { __assign } from "tslib";
import { handleActions, combineActions } from 'redux-actions';
import { initialize, updateCommentsOrder, updateEmailSuccess, updateEmail, updateEmailFail, resendVerificationEmail, resendVerificationEmailSuccess, resendVerificationEmailFail, setViewMode, setIsMobile, setThemeSkin, setFeedbackCount, toggleTheme, setTheme, setCookieSettingsSuccess, setCookieSettingsFail, setCookieSettings, setChatSettingMuted, setChatSettingOnline, setChatSettingSoundsMuted, } from './actions';
import { ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import { reduxKey } from './constants';
import { siteHeaderNotificationsOpened, siteHeaderWatchOpened, siteHeaderNotesOpened, resetNewFeedback, deletePortfolioSuccess, } from '../SiteHeader/redux/actions';
import { awardBadgeSuccess } from '../coreBadge/redux/actionCreators';
var defaultState = {
    isLoggedIn: false,
};
var reducer = handleActions((_a = {},
    _a[initialize.toString()] = function (state, action) {
        return action.payload
            ? __assign(__assign({}, state), action.payload.sessionData) : state;
    },
    _a[combineActions(siteHeaderNotificationsOpened, resetNewFeedback).toString()] = function (state) {
        return state.counts && state.counts.feedback
            ? __assign(__assign({}, state), { counts: __assign(__assign({}, state.counts), { feedback: 0 }) }) : state;
    },
    _a[siteHeaderWatchOpened.toString()] = function (state) {
        return state.counts && state.counts.watch
            ? __assign(__assign({}, state), { counts: __assign(__assign({}, state.counts), { watch: 0 }) }) : state;
    },
    _a[siteHeaderNotesOpened.toString()] = function (state) {
        return state.counts && state.counts.notes
            ? __assign(__assign({}, state), { counts: __assign(__assign({}, state.counts), { notes: 0 }) }) : state;
    },
    _a[deletePortfolioSuccess.toString()] = function (state) { return (__assign(__assign({}, state), { hasWixPortfolio: false })); },
    _a[updateCommentsOrder.toString()] = function (state, _a) {
        var payload = _a.payload;
        return payload && payload.order !== state.commentsOrder
            ? __assign(__assign({}, state), { commentsOrder: payload.order }) : state;
    },
    _a[toggleTheme.toString()] = function (state) {
        return __assign(__assign({}, state), { theme: state.theme === ThemeOptions.LIGHT
                ? ThemeOptions.DARK
                : ThemeOptions.LIGHT });
    },
    _a[setTheme.toString()] = function (state, _a) {
        var payload = _a.payload;
        return payload
            ? __assign(__assign({}, state), { theme: payload.theme, themeSkin: undefined }) : state;
    },
    _a[setThemeSkin.toString()] = function (state, _a) {
        var payload = _a.payload;
        return payload
            ? __assign(__assign({}, state), { 
                // If we ever have more skins, parse themeSkin for the base theme
                theme: ThemeOptions.LIGHT, themeSkin: payload.themeSkin }) : state;
    },
    _a[setIsMobile.toString()] = function (state, _a) {
        var isMobile = _a.payload.isMobile;
        return (__assign(__assign({}, state), { isMobile: isMobile }));
    },
    _a[setFeedbackCount.toString()] = function (state, _a) {
        var count = _a.payload;
        return (__assign(__assign({}, state), { counts: __assign(__assign({}, state.counts), { feedback: count }) }));
    },
    _a[resendVerificationEmail.toString()] = function (state) { return (__assign(__assign({}, state), { updateProgress: __assign(__assign({}, state.updateProgress), { isResendInProgress: true }) })); },
    _a[resendVerificationEmailSuccess.toString()] = function (state) { return (__assign(__assign({}, state), { updateProgress: __assign(__assign({}, state.updateProgress), { isResendInProgress: false, isSendingDone: true }) })); },
    _a[resendVerificationEmailFail.toString()] = function (state) { return (__assign(__assign({}, state), { updateProgress: __assign(__assign({}, state.updateProgress), { isResendInProgress: false, isSendingDone: false }) })); },
    _a[updateEmail.toString()] = function (state) { return (__assign(__assign({}, state), { updateProgress: __assign(__assign({}, state.updateProgress), { isEmailChangeInProgress: true, isSendingDone: false }) })); },
    _a[updateEmailSuccess.toString()] = function (state, _a) {
        var payload = _a.payload;
        return payload
            ? __assign(__assign({}, state), { verificationEmail: payload.email, updateProgress: __assign(__assign({}, state.updateProgress), { isEmailChangeInProgress: false, isSendingDone: true }) }) : state;
    },
    _a[updateEmailFail.toString()] = function (state) { return (__assign(__assign({}, state), { updateProgress: __assign(__assign({}, state.updateProgress), { isEmailChangeInProgress: false, isSendingDone: false, updateFailed: true }) })); },
    _a[setViewMode.toString()] = function (state, _a) {
        var nextViewMode = _a.payload.nextViewMode;
        return (__assign(__assign({}, state), { deviationViewMode: nextViewMode }));
    },
    _a[setCookieSettingsSuccess.toString()] = function (state) { return (__assign(__assign({}, state), { hasAcceptedCookies: true })); },
    _a[setCookieSettingsFail.toString()] = function (state) { return (__assign(__assign({}, state), { 
        // need to determine if on fail we should accept the basic cookies and hide the popup so it's not annnoying
        hasAcceptedCookies: false })); },
    _a[setCookieSettings.toString()] = function (state, action) { return (__assign(__assign({}, state), { cookiePrivacySettings: __assign(__assign({}, state.cookiePrivacySettings), action.payload) })); },
    _a[setChatSettingMuted.toString()] = function (state, _a) {
        var value = _a.payload.value;
        return (__assign(__assign({}, state), { chat: __assign(__assign({}, state.chat), { muted: value }) }));
    },
    _a[setChatSettingSoundsMuted.toString()] = function (state, _a) {
        var value = _a.payload.value;
        return (__assign(__assign({}, state), { chat: __assign(__assign({}, state.chat), { muteSound: value }) }));
    },
    _a[setChatSettingOnline.toString()] = function (state, _a) {
        var value = _a.payload.value;
        return (__assign(__assign({}, state), { chat: __assign(__assign({}, state.chat), { online: value }) }));
    },
    _a[awardBadgeSuccess.toString()] = function (state, action) { return (__assign(__assign({}, state), { counts: __assign(__assign({}, state.counts), { fragments: action.payload.newBalance }) })); },
    _a), defaultState);
export default (_b = {},
    _b[reduxKey] = reducer,
    _b);
//# sourceMappingURL=reducers.js.map